import Vue from 'vue'
import verificationApi from '@/apis/verification'
import commonApi from '@/apis/common'
import {
  RESET_STATE,
  SET_VERIFICATION_RESULT,
  SET_VERIFICATION_ISCOMPLETED,
  GET_VERIFICATION_REQUEST,
  GET_VERIFICATION_SUCCESS,
  GET_VERIFICATION_FAILURE,
  GET_VERIFICATION_LIVESNAPSHOTURL_REQUEST,
  GET_VERIFICATION_LIVESNAPSHOTURL_SUCCESS,
  GET_VERIFICATION_LIVESNAPSHOTURL_FAILURE,
  GET_VERIFICATION_LIVESNAPSHOT_REQUEST,
  GET_VERIFICATION_LIVESNAPSHOT_SUCCESS,
  GET_VERIFICATION_LIVESNAPSHOT_FAILURE,
  GET_VERIFICATION_EVENT_REQUEST,
  GET_VERIFICATION_EVENT_SUCCESS,
  GET_VERIFICATION_EVENT_FAILURE,
  GET_VERIFICATION_EVENT_MEDIAS_REQUEST,
  GET_VERIFICATION_EVENT_MEDIAS_SUCCESS,
  GET_VERIFICATION_EVENT_MEDIAS_FAILURE,
  GET_VERIFICATION_EVENT_RECORD_REQUEST,
  GET_VERIFICATION_EVENT_RECORD_SUCCESS,
  GET_VERIFICATION_EVENT_RECORD_FAILURE,
  GET_VERIFICATION_PRIVACYSTATUS_REQUEST,
  GET_VERIFICATION_PRIVACYSTATUS_SUCCESS,
  GET_VERIFICATION_PRIVACYSTATUS_FAILURE,
  CREATE_VERIFICATION_RESPONSE_REQUEST,
  CREATE_VERIFICATION_RESPONSE_SUCCESS,
  CREATE_VERIFICATION_RESPONSE_FAILURE,
  SET_VERIFICATION_PRIVACY_DISABLED_DURATION_REQUEST,
  SET_VERIFICATION_PRIVACY_DISABLED_DURATION_SUCCESS,
  SET_VERIFICATION_PRIVACY_DISABLED_DURATION_FAILURE,
  GET_VERIFICATION_SITE_VERIFICATION_DURATION_REQUEST,
  GET_VERIFICATION_SITE_VERIFICATION_DURATION_SUCCESS,
  GET_VERIFICATION_SITE_VERIFICATION_DURATION_FAILURE,
  CHECK_EVENT_RECORD_CODEC_DONE,
  REMAIN_VERIFICATION_TIME_UPDATE
} from '../mutation-types'

let initialState = {
  isGetVerificationSuccess: false,
  getVerificationErrorCode: null,
  verificationResult: null,
  verificationIsCompleted: null,
  verification: {},
  requesterDealer: {},
  requesteeMe: {},
  requesteeSite: {},
  requesteeSiteContacts: {},
  privacyDeviceList: [],
  liveSnapshotUrl: {},
  liveSnapshot: {},
  event: {},
  eventMedias: [],
  eventRecords: {},
  siteVerificationDuration: 120,
  remainVerificationTime: 120,
  status: {
    getVerification: null,
    getPrivacyStatus: null,
    getLiveSnapshot: null,
    getLiveSnapshotUrl: null,
    getVerificationEvent: null,
    getEventMedias: null,
    getEventRecord: {},
    createVerificationResponse: null,
    setPrivacyDisabledDuration: null,
    getSiteVerificationDuration: null,
    checkVideoCodec: null
  }
}

// initial state
const state = Vue.util.extend({}, initialState)

// getters
const getters = {
  isGetVerificationSuccess: function (state) {
    return state.isGetVerificationSuccess
  },
  getVerificationErrorCode: function (state) {
    return state.getVerificationErrorCode
  },
  verificationResult: function (state) {
    return state.verificationResult
  },
  verificationIsCompleted: function (state) {
    return state.verificationIsCompleted
  },
  verificationInfo: function (state) {
    return state.verification
  },
  verificationRequesterDealer: function (state) {
    return state.requesterDealer
  },
  verificationRequesteeMe: function (state) {
    return state.requesteeMe
  },
  verificationRequesteeSite: function (state) {
    return state.requesteeSite
  },
  verificationRequesteeSiteContacts: function (state) {
    return state.requesteeSiteContacts
  },
  verificationSitePrivacyDeviceList: function (state) {
    return state.privacyDeviceList
  },
  verificationLiveSnapshot: function (state) {
    return state.liveSnapshot
  },
  verificationLiveSnapshotUrl: function (state) {
    return state.liveSnapshotUrl
  },
  verificationEvent: function (state) {
    return state.event
  },
  verificationEventMedias: function (state) {
    return state.eventMedias
  },
  verificationEventRecords: function (state) {
    return function (recordId) {
      return state.eventRecords[recordId]
    }
  },
  remainVerificationTime: function (state) {
    return state.remainVerificationTime
  },
  statusGetVerification: function (state) {
    return state.status.getVerification
  },
  statusGetVerificationSitePrivacyStatus: function (state) {
    return state.status.getPrivacyStatus
  },
  statusGetVerificationLiveSnapshot: function (state) {
    return state.status.getLiveSnapshot
  },
  statusGetVerificationEvent: function (state) {
    return state.status.getVerificationEvent
  },
  statusGetVerificationEventMedias: function (state) {
    return state.status.getEventMedias
  },
  statusGetVerificationEventRecord: function (state) {
    return function (recordId) {
      return state.status.getEventRecord[recordId]
    }
  },
  statusCreateVerificationResponse: function (state) {
    return state.status.createVerificationResponse
  },
  statusSetVerificationPrivacyDisabledDuration: function (state) {
    return state.status.setPrivacyDisabledDuration
  },
  siteVerificationDuration: function (state) {
    return state.siteVerificationDuration
  },
  statusCheckVerificationVideoCodec: function (state) {
    return state.status.checkVideoCodec
  },
  statusGetVerificationLiveSnapshotUrl: function (state) {
    return state.status.getLiveSnapshotUrl
  }
}

// actions
const actions = {
  getVerification: function ({commit, dispatch}) {
    commit(GET_VERIFICATION_REQUEST)
    return new Promise((resolve, reject) => {
      verificationApi.getVerification().then(
        res => {
          dispatch('checkOnlineStatusByApiResponse', res)
          commit(GET_VERIFICATION_SUCCESS, {data: res.body})
          resolve()
        },
        err => {
          Vue.logger.error(err)
          dispatch('checkOnlineStatusByApiResponse', err)
          commit(GET_VERIFICATION_FAILURE, err.status)
          reject(new Error(err.statusText))
        }
      )
    })
  },
  getVerificationSitePrivacyStatus: function ({commit, dispatch}) {
    commit(GET_VERIFICATION_PRIVACYSTATUS_REQUEST)
    return new Promise((resolve, reject) => {
      verificationApi.getVerificationPrivacyStatus().then(
        res => {
          dispatch('checkOnlineStatusByApiResponse', res)
          try {
            commit(GET_VERIFICATION_PRIVACYSTATUS_SUCCESS, {data: res.body})
            resolve()
          } catch (err) {
            commit(GET_VERIFICATION_PRIVACYSTATUS_FAILURE)
            reject(new Error(('No snapshot ' + err.message)))
          }
        },
        err => {
          Vue.logger.error(err)
          dispatch('checkOnlineStatusByApiResponse', err)
          commit(GET_VERIFICATION_PRIVACYSTATUS_FAILURE)
          reject(new Error(err.statusText))
        }
      )
    })
  },
  getVerificationLiveSnapshot: function ({commit, dispatch}) {
    commit(GET_VERIFICATION_LIVESNAPSHOT_REQUEST)
    return new Promise((resolve, reject) => {
      verificationApi.getVerificationLiveSnapshot().then(
        res => {
          dispatch('checkOnlineStatusByApiResponse', res)
          try {
            commit(GET_VERIFICATION_LIVESNAPSHOT_SUCCESS, {data: res.body})
            resolve()
          } catch (err) {
            commit(GET_VERIFICATION_LIVESNAPSHOT_FAILURE)
            reject(new Error(('No snapshot ' + err.message)))
          }
        },
        err => {
          Vue.logger.error(err)
          dispatch('checkOnlineStatusByApiResponse', err)
          commit(GET_VERIFICATION_LIVESNAPSHOT_FAILURE)
          reject(new Error(err.statusText))
        }
      )
    })
  },
  getVerificationLiveSnapshotUrl: function ({commit, dispatch}) {
    commit(GET_VERIFICATION_LIVESNAPSHOTURL_REQUEST)
    return new Promise((resolve, reject) => {
      verificationApi.getVerificationLiveSnapshotUrlV2().then(
        res => {
          dispatch('checkOnlineStatusByApiResponse', res)
          try {
            commit(GET_VERIFICATION_LIVESNAPSHOTURL_SUCCESS, {data: res.body})
            resolve()
          } catch (err) {
            commit(GET_VERIFICATION_LIVESNAPSHOTURL_FAILURE)
            reject(new Error(('No snapshot ' + err.message)))
          }
        },
        err => {
          Vue.logger.error(err)
          dispatch('checkOnlineStatusByApiResponse', err)
          commit(GET_VERIFICATION_LIVESNAPSHOTURL_FAILURE)
          reject(new Error(err.statusText))
        }
      )
    })
  },
  getVerificationLiveSnapshotV2: function ({commit, dispatch}, {snapshotUrl, token}) {
    commit(GET_VERIFICATION_LIVESNAPSHOT_REQUEST)
    return new Promise((resolve, reject) => {
      verificationApi.getVerificationLiveSnapshotV2(snapshotUrl, token).then(
        res => {
          dispatch('checkOnlineStatusByApiResponse', res)
          try {
            commit(GET_VERIFICATION_LIVESNAPSHOT_SUCCESS, {data: res.body})
            resolve()
          } catch (err) {
            commit(GET_VERIFICATION_LIVESNAPSHOT_FAILURE)
            reject(new Error(('No snapshot ' + err.message)))
          }
        },
        err => {
          Vue.logger.error(err)
          dispatch('checkOnlineStatusByApiResponse', err)
          commit(GET_VERIFICATION_LIVESNAPSHOT_FAILURE)
          reject(new Error(err.statusText))
        }
      )
    })
  },
  getVerificationEvent: function ({commit, dispatch}) {
    commit(GET_VERIFICATION_EVENT_REQUEST)
    commit(GET_VERIFICATION_EVENT_MEDIAS_REQUEST)
    return new Promise((resolve, reject) => {
      verificationApi.getVerificationEvent().then(
        res => {
          dispatch('checkOnlineStatusByApiResponse', res)
          if ('event' in res.body) {
            commit(GET_VERIFICATION_EVENT_SUCCESS, {data: res.body['event']})
          } else {
            commit(GET_VERIFICATION_EVENT_FAILURE)
          }
          if ('records' in res.body) {
            commit(GET_VERIFICATION_EVENT_MEDIAS_SUCCESS, {data: res.body['records']})
          } else {
            commit(GET_VERIFICATION_EVENT_MEDIAS_FAILURE)
          }
          resolve()
        },
        err => {
          Vue.logger.error(err)
          dispatch('checkOnlineStatusByApiResponse', err)
          commit(GET_VERIFICATION_EVENT_FAILURE)
          commit(GET_VERIFICATION_EVENT_MEDIAS_FAILURE)
          reject(new Error(err.statusText))
        }
      )
    })
  },
  getVerificationEventRecord: function ({commit, dispatch, getters}, {snapshotIndex, recordId, url}) {
    commit(GET_VERIFICATION_EVENT_RECORD_REQUEST, {recordId: recordId})
    return new Promise((resolve, reject) => {
      commonApi.downloadImage(url).then(
        res => {
          dispatch('checkOnlineStatusByApiResponse', res)
          commit(GET_VERIFICATION_EVENT_RECORD_SUCCESS, {
            snapshotIndex: snapshotIndex,
            recordId: recordId,
            data: res.body
          })
          dispatch('checkEventRecordMP4Codec', {
            snapshotIndex: snapshotIndex,
            blob: res.body
          })
          resolve()
        },
        err => {
          Vue.logger.error(err)
          dispatch('checkOnlineStatusByApiResponse', err)
          commit(GET_VERIFICATION_EVENT_RECORD_FAILURE, {
            snapshotIndex: snapshotIndex,
            recordId: recordId
          })
          reject(new Error(err.statusText))
        }
      )
    })
  },
  checkEventRecordMP4Codec: function ({commit, dispatch, getters}, {snapshotIndex, blob}) {
    return new Promise((resolve, reject) => {
      // UPDATE codec
      let eventMedia = state.eventMedias[snapshotIndex]
      if (!eventMedia) return
      if (('' + state.eventMedias[snapshotIndex].format).toLocaleLowerCase() !== 'mp4') {
        resolve()
        return
      }
      Vue.tool.getCodecFromMP4(blob).then(codec => {
        commit(CHECK_EVENT_RECORD_CODEC_DONE, {
          snapshotIndex: snapshotIndex,
          codec: codec
        })
        resolve()
      })
    })
  },
  createVerificationResponse: function ({commit, dispatch}, {isCrime}) {
    commit(CREATE_VERIFICATION_RESPONSE_REQUEST)
    return new Promise((resolve, reject) => {
      verificationApi.createVerificationResponse(isCrime).then(
        res => {
          dispatch('checkOnlineStatusByApiResponse', res)
          try {
            commit(CREATE_VERIFICATION_RESPONSE_SUCCESS, {data: res.body})
            resolve()
          } catch (err) {
            commit(CREATE_VERIFICATION_RESPONSE_FAILURE)
            reject(new Error((err.message)))
          }
        },
        err => {
          Vue.logger.error(err)
          dispatch('checkOnlineStatusByApiResponse', err)
          commit(CREATE_VERIFICATION_RESPONSE_FAILURE)
          reject(new Error(err.statusText))
        }
      )
    })
  },
  setVerificationPrivacyDisabledDuration: function ({commit, dispatch}, {durationSec}) {
    commit(SET_VERIFICATION_PRIVACY_DISABLED_DURATION_REQUEST)
    return new Promise((resolve, reject) => {
      verificationApi.setPrivacyDisabledDuration(durationSec).then(
        res => {
          dispatch('checkOnlineStatusByApiResponse', res)
          try {
            commit(SET_VERIFICATION_PRIVACY_DISABLED_DURATION_SUCCESS, {data: res.body})
            resolve()
          } catch (err) {
            commit(SET_VERIFICATION_PRIVACY_DISABLED_DURATION_FAILURE)
            reject(new Error((err.message)))
          }
        },
        err => {
          Vue.logger.error(err)
          dispatch('checkOnlineStatusByApiResponse', err)
          commit(SET_VERIFICATION_PRIVACY_DISABLED_DURATION_FAILURE)
          reject(new Error(err.statusText))
        }
      )
    })
  },
  getSiteVerificationDuration: function ({commit, dispatch}) {
    commit(GET_VERIFICATION_SITE_VERIFICATION_DURATION_REQUEST)
    return new Promise((resolve, reject) => {
      verificationApi.getSiteVerificationDuration().then(
        res => {
          // dispatch('checkOnlineStatusByApiResponse', res)
          // console.log(res)
          commit(GET_VERIFICATION_SITE_VERIFICATION_DURATION_SUCCESS, {data: res.body})
          resolve(res.body)
        },
        err => {
          Vue.logger.error(err)
          // dispatch('checkOnlineStatusByApiResponse', err)
          // commit(GET_VERIFICATION_EVENT_FAILURE)
          commit(GET_VERIFICATION_SITE_VERIFICATION_DURATION_FAILURE)
          reject(new Error(err.statusText))
        }
      )
    })
  }
}
// mutations
const mutations = {
  [RESET_STATE]: function (state) {
    for (let f in state) {
      Vue.set(state, f, initialState[f])
    }
  },
  // //////////////////////////////////////////////
  [SET_VERIFICATION_RESULT]: function (state, {result}) {
    state.verificationResult = result
  },
  // //////////////////////////////////////////////
  [SET_VERIFICATION_ISCOMPLETED]: function (state, {isCompleted}) {
    state.verificationIsCompleted = isCompleted
  },
  // //////////////////////////////////////////////
  [GET_VERIFICATION_REQUEST]: function (state) {
    state.status.getVerification = 'requested'
  },
  [GET_VERIFICATION_SUCCESS]: function (state, {data}) {
    try {
      // activity list and response list
      let activityList = []
      let responseList = {}
      data.activity.map(activityData => {
        let activityInfo = {
          verificationId: activityData.verification_id,
          email: activityData.email,
          userId: activityData.user_id,
          contactId: activityData.contact_id,
          isVerificationCheckedByUser: !!activityData.action,
          responseType: activityData.type,
          response: null,
          geoIpMetaData: activityData.geoip_meta,
          createdDate: activityData.created ? new Date(activityData.created) : null
        }
        // set Response in human readable format
        if (activityInfo.responseType === 1) {
          activityInfo.response = 'dispatch'
        } else if (activityInfo.responseType === 2) {
          activityInfo.response = 'cancel'
        } else if (activityInfo.isVerificationCheckedByUser) {
          activityInfo.response = 'viewed event'
        } else {
          activityInfo.response = null
        }
        activityList.push(activityInfo)
        // prepare response list of each contact
        if (!responseList[activityInfo.contactId]) {
          responseList[activityInfo.contactId] = {}
        }
        responseList[activityInfo.contactId][activityInfo.createdDate.getTime()] = {
          response: activityInfo.response,
          geoIpMetaData: activityInfo.geoIpMetaData
        }
      })
      // verificationInfo
      let verificationInfo = {
        requesterUserId: data.user_id,
        statusInfo: {
          createdDate: data.verification_created ? new Date(data.verification_created) : null
        },
        activityList: activityList,
        responseList: responseList
      }
      state.verification = verificationInfo
      // siteInfo
      let siteInfo = {
        siteId: data.site_id,
        siteName: data.name,
        address: (data.address2 ? data.address2 + ' ' : '') + data.address1,
        timezone: data.timezone,
        lat: data.lat,
        lng: data.lng
      }
      // state.siteVerificationDuration = data.verification_duration // verification duration. !!!@@@@
      state.requesteeSite = siteInfo
      // requesteeMe
      let meInfo = {
        contactId: data.my_contact_id,
        userId: data.my_user_id
      }
      state.requesteeMe = meInfo
      // requesteeSiteContacts
      let contacts = {}
      data.contacts.map(contactData => {
        let contactInfo = {
          contactId: contactData.contact_id,
          title: contactData.title,
          name: contactData.name,
          email: contactData.email,
          phone: contactData.phone,
          slotNumber: contactData.slot_number,
          isVerificationContact: contactData.is_verification_contact,
          siteInfo: {
            siteId: contactData.site_id
          },
          statusInfo: {
            createdDate: contactData.created ? new Date(contactData.created) : null
          }
        }
        contacts[contactData.contact_id] = contactInfo
      })
      state.requesteeSiteContacts = contacts
      // dealerInfo
      let dealerData = data.requestby.dealer
      let dealerInfo = {
        dealerId: dealerData.dealer_id,
        dealerName: dealerData.company_name,
        profilePictureUrl: dealerData.provider_picture,
        ownerInfo: {
          userId: dealerData.user_id,
          email: dealerData.account_email,
          firstName: dealerData.account_firstname,
          lastName: dealerData.account_lastname
        },
        locationInfo: {
          address: (dealerData.company_address2 ? dealerData.company_address2 + ' ' : '') + dealerData.company_address1,
          postalCode: dealerData.company_zipcode,
          timezone: dealerData.timezone,
          lat: dealerData.lat,
          lng: dealerData.lng
        },
        contactInfo: {
          phone: dealerData.company_phone,
          email: dealerData.company_email
        },
        statusInfo: {
          isDeleted: !!dealerData.is_deleted,
          isRegistered: !!dealerData.is_registered,
          isMonitoringBlocked: !!dealerData.is_monitoring_block,
          createdDate: dealerData.created ? new Date(dealerData.created) : null,
          registeredDate: dealerData.registered_time ? new Date(dealerData.registered_time) : null,
          deletedDate: dealerData.deleted_time ? new Date(dealerData.deleted_time) : null
        }
      }
      state.requesterDealer = dealerInfo
      state.status.getVerification = 'successful'
      state.isGetVerificationSuccess = true
    } catch (err) {
      Vue.logger.error('GET_VERIFICATION_SUCCESS: Failed')
      Vue.logger.error(err)
      console.warn(err)
      state.status.getVerification = 'failed'
      state.isGetVerificationSuccess = false
    }
  },
  [GET_VERIFICATION_FAILURE]: function (state, statusCode) {
    state.status.getVerification = 'failed'
    state.getVerificationErrorCode = statusCode
    state.isGetVerificationSuccess = false
  },
  // //////////////////////////////////////////////
  [GET_VERIFICATION_PRIVACYSTATUS_REQUEST]: function (state) {
    state.status.getPrivacyStatus = 'requested'
  },
  [GET_VERIFICATION_PRIVACYSTATUS_SUCCESS]: function (state, {data}) {
    try {
      let privacyDeviceList = []
      data.map(deviceInfo => {
        privacyDeviceList.push(deviceInfo.device_id + '')
      })
      state.privacyDeviceList = privacyDeviceList
      state.status.getPrivacyStatus = 'successful'
    } catch (err) {
      Vue.logger.error('GET_VERIFICATION_PRIVACYSTATUS_SUCCESS: Failed')
      Vue.logger.error(err)
      state.status.getPrivacyStatus = 'failed'
    }
  },
  [GET_VERIFICATION_PRIVACYSTATUS_FAILURE]: function (state) {
    state.status.getPrivacyStatus = 'failed'
  },
  // //////////////////////////////////////////////
  [GET_VERIFICATION_LIVESNAPSHOTURL_REQUEST]: function (state) {
    state.status.getLiveSnapshotUrl = 'requested'
  },
  [GET_VERIFICATION_LIVESNAPSHOTURL_SUCCESS]: function (state, {data}) {
    try {
      state.liveSnapshotUrl = data
      state.status.getLiveSnapshotUrl = 'successful'
    } catch (err) {
      Vue.logger.error('GET_VERIFICATION_LIVESNAPSHOTURL_SUCCESS: Failed')
      Vue.logger.error(err)
      state.status.getLiveSnapshotUrl = 'failed'
    }
  },
  [GET_VERIFICATION_LIVESNAPSHOTURL_FAILURE]: function (state) {
    state.status.getLiveSnapshotUrl = 'failed'
  },
  [GET_VERIFICATION_LIVESNAPSHOT_REQUEST]: function (state) {
    state.status.getLiveSnapshot = 'requested'
  },
  [GET_VERIFICATION_LIVESNAPSHOT_SUCCESS]: function (state, {data}) {
    try {
      const timestamp = data.snapshotTimestamp ? data.snapshotTimestamp * 1000 : data.timestamp
      let snapshotInfo = {
        data: 'data:image/jpg;base64,' + data.data,
        timestamp: timestamp
      }
      state.liveSnapshot = snapshotInfo
      state.status.getLiveSnapshot = 'successful'
    } catch (err) {
      Vue.logger.error('GET_VERIFICATION_LIVESNAPSHOT_SUCCESS: Failed')
      Vue.logger.error(err)
      state.status.getLiveSnapshot = 'failed'
    }
  },
  [GET_VERIFICATION_LIVESNAPSHOT_FAILURE]: function (state) {
    state.status.getLiveSnapshot = 'failed'
  },
  // //////////////////////////////////////////////
  [GET_VERIFICATION_EVENT_REQUEST]: function (state) {
    state.status.getVerificationEvent = 'requested'
  },
  [GET_VERIFICATION_EVENT_SUCCESS]: function (state, {data}) {
    try {
      let eventInfo = {
        eventId: data.event_id,
        eventStatus: data.status,
        eventType: data.type,
        eventTimestamp: data.timestamp,
        deviceInfo: {
          deviceId: data.device_id
        }
      }
      state.event = eventInfo
      state.status.getVerificationEvent = 'successful'
    } catch (err) {
      Vue.logger.error('GET_VERIFICATION_EVENT_SUCCESS: Failed')
      Vue.logger.error(err)
      state.status.getVerificationEvent = 'failed'
    }
  },
  [GET_VERIFICATION_EVENT_FAILURE]: function (state) {
    state.status.getVerificationEvent = 'failed'
  },
  // //////////////////////////////////////////////
  [GET_VERIFICATION_EVENT_MEDIAS_REQUEST]: function (state) {
    state.status.getEventMedias = 'requested'
  },
  [GET_VERIFICATION_EVENT_MEDIAS_SUCCESS]: function (state, {data}) {
    try {
      let eventMediasInfoList = []
      data.map(eventMediasData => {
        if ((eventMediasData.format + '').toLowerCase() === 'jpg' ||
        (eventMediasData.format + '').toLowerCase() === 'mp4'
        ) {
          let eventMediasInfo = {
            recordId: eventMediasData.record_id,
            eventId: eventMediasData.event_id,
            url: eventMediasData.url,
            format: (eventMediasData.format + '').toLowerCase(),
            deviceInfo: {
              deviceId: eventMediasData.device_id
            },
            statusInfo: {
              createdDate: eventMediasData.created ? new Date(eventMediasData.created) : null,
              reallyUploaded: null, // it is to validate 'eventMediasData.completed'
              codec: null,
              completed: !!eventMediasData.completed
            }
          }
          eventMediasInfoList.push(eventMediasInfo)
        }
      })
      state.eventMedias = eventMediasInfoList
      state.status.getEventMedias = 'successful'
    } catch (err) {
      Vue.logger.error('GET_VERIFICATION_EVENT_MEDIAS_SUCCESS: Failed')
      Vue.logger.error(err)
      state.status.getEventMedias = 'failed'
    }
  },
  [GET_VERIFICATION_EVENT_MEDIAS_FAILURE]: function (state) {
    state.status.getEventMedias = 'failed'
  },
  // //////////////////////////////////////////////
  [GET_VERIFICATION_EVENT_RECORD_REQUEST]: function (state, {recordId}) {
    state.status.getEventRecord[recordId] = 'requested'
  },
  [GET_VERIFICATION_EVENT_RECORD_SUCCESS]: function (state, {snapshotIndex, recordId, data}) {
    try {
      let urlCreator = window.URL || window.webkitURL
      let imageUrl = urlCreator.createObjectURL(data)
      state.eventRecords = {...state.eventRecords, [recordId]: imageUrl}
      state.status.getEventRecord[recordId] = 'successful'
      // it is to validate 'eventMediasData.completed'
      state.eventMedias[snapshotIndex].statusInfo.completed = true
      state.eventMedias[snapshotIndex].statusInfo.reallyUploaded = true
    } catch (err) {
      Vue.logger.error('GET_VERIFICATION_EVENT_RECORD_SUCCESS: Failed')
      Vue.logger.error(err)
      state.status.getEventRecord[recordId] = 'failed'
      // it is to validate 'eventMediasData.completed'
      state.eventMedias[snapshotIndex].statusInfo.completed = false
      state.eventMedias[snapshotIndex].statusInfo.reallyUploaded = false
    }
  },
  [GET_VERIFICATION_EVENT_RECORD_FAILURE]: function (state, {snapshotIndex, recordId}) {
    state.status.getEventRecord[recordId] = 'failed'
    // it is to validate 'eventMediasData.completed'
    state.eventMedias[snapshotIndex].statusInfo.completed = false
    state.eventMedias[snapshotIndex].statusInfo.reallyUploaded = false
  },
  // GET_VERIFICATION_SITE_VERIFICATION_DURATION ////
  [GET_VERIFICATION_SITE_VERIFICATION_DURATION_REQUEST]: function (state) {
    state.siteVerificationDuration = 120
    state.status.getSiteVerificationDuration = 'requested'
  },
  [GET_VERIFICATION_SITE_VERIFICATION_DURATION_SUCCESS]: function (state, {data}) {
    // console.log(data)
    state.siteVerificationDuration = data.verification_duration
    // state.siteVerificationDuration = {...state.siteVerificationDuration}
    state.status.getSiteVerificationDuration = 'successful'
  },
  [GET_VERIFICATION_SITE_VERIFICATION_DURATION_FAILURE]: function (state) {
    state.siteVerificationDuration = 120
    state.status.getSiteVerificationDuration = 'failed'
  },
  // //////////////////////////////////////////////
  [CREATE_VERIFICATION_RESPONSE_REQUEST]: function (state) {
    state.status.createVerificationResponse = 'requested'
  },
  [CREATE_VERIFICATION_RESPONSE_SUCCESS]: function (state, {data}) {
    try {
      // console.warn(data)
      state.status.createVerificationResponse = 'successful'
    } catch (err) {
      Vue.logger.error('CREATE_VERIFICATION_RESPONSE_SUCCESS: Failed')
      Vue.logger.error(err)
      state.status.createVerificationResponse = 'failed'
    }
  },
  [CREATE_VERIFICATION_RESPONSE_FAILURE]: function (state) {
    state.status.createVerificationResponse = 'failed'
  },
  // //////////////////////////////////////////////
  [SET_VERIFICATION_PRIVACY_DISABLED_DURATION_REQUEST]: function (state) {
    state.status.setPrivacyDisabledDuration = 'requested'
  },
  [SET_VERIFICATION_PRIVACY_DISABLED_DURATION_SUCCESS]: function (state, {data}) {
    try {
      console.warn(data)
      state.status.setPrivacyDisabledDuration = 'successful'
    } catch (err) {
      Vue.logger.error('SET_VERIFICATION_PRIVACY_DISABLED_DURATION_SUCCESS: Failed')
      Vue.logger.error(err)
      state.status.setPrivacyDisabledDuration = 'failed'
    }
  },
  [SET_VERIFICATION_PRIVACY_DISABLED_DURATION_FAILURE]: function (state) {
    state.status.setPrivacyDisabledDuration = 'failed'
  },
  [CHECK_EVENT_RECORD_CODEC_DONE]: function (state, {snapshotIndex, codec}) {
    try {
      // UPDATE codec
      if (('' + state.eventMedias[snapshotIndex].format).toLocaleLowerCase() !== 'mp4') return
      state.eventMedias[snapshotIndex].statusInfo.codec = codec
      state.status.checkVideoCodec = 'successful'
      // console.log(state.eventSnapshots[eventId][snapshotIndex].statusInfo.codec)
    } catch (err) {
      Vue.logger.error('CHECK_MONITORING_EVENT_RECORD_CODEC_DONE: Failed')
      Vue.logger.error(err)
    }
  },
  [REMAIN_VERIFICATION_TIME_UPDATE]: function (state, {remainTime}) {
    state.remainVerificationTime = remainTime
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/verification.js